<template>
  <v-container>
    <v-card>
      <v-card class="lime elevation-0 rounded-0 mb-2" dark tile>
        <v-card-title>
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <h3 style="color:white">KNDI O.S.P {{ exam_name }}</h3>
        </v-card-title>
      </v-card>
      <v-container>
        <!--<v-flex xs12 md12 class="mb-3">
          <h4>
            Due to COVID-19 restrictions we have revised the examination centers
            to the following centers. Please select your prefereable examination
            center slot for the Professional Upgrading Examination.
          </h4>
        </v-flex>-->
        <v-flex xs12 md12 class="mb-3">
          Please select your prefereable examination center slot for the
          Professional Upgrading Examination.
        </v-flex>
        <form>
          <v-card class="mb-5" color="grey lighten-4" height flat>
            <v-progress-linear
              :indeterminate="true"
              color="lime"
              v-if="sending"
            ></v-progress-linear>
            <v-card-text>
              <v-flex xs12 sm12 md12>
                <v-radio-group
                  v-model="user_slot"
                  :error-messages="errors.slot"
                >
                  <v-radio
                    v-for="a_slot in models"
                    :key="a_slot.id"
                    :label="a_slot.name"
                    :value="a_slot.id"
                    color="lime"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-card-text>
          </v-card>
          <v-btn
            color="lime"
            class="white--text"
            @click.native="submit"
            v-if="disabled == false"
            >submit</v-btn
          >
          <v-btn disabled v-if="disabled == true">
            <v-progress-circular
              :width="3"
              :size="15"
              indeterminate
              color="white"
            ></v-progress-circular
            >&nbsp; checking
          </v-btn>
        </form>
      </v-container>

      <v-dialog v-model="downloaded" persistent width="300">
        <v-card color="lime" dark>
          <v-card-text>
            Please stand by
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import Vue from "vue"
import { examSlotIndexUrl, examSlotCreateUrl } from "@/config"
import axios from "axios"
import swal from "sweetalert2"
export default {
  data() {
    return {
      snackbar: false,
      snackbar_text: "",
      y: "",
      x: "",
      mode: "",
      e1: 0,
      maxCount: 140,
      remainingCount: 140,
      checking: false,
      disabled: false,
      step_one: true,
      errors: {},
      exam_name: "",
      models: [],
      user_slot: "",
      exam_name: "",
      app_tbl_id: "",
      sending: false,
      downloaded: false,
      question_number: "",
      photo_upload: false,
      file_name_c: "",
      photo: "",
      start: false
    }
  },
  beforeMount() {
    if (this.$route.params.token != "") {
      this.fetchData()
      this.downloaded = true
    } else {
      swal({
        title: "Unauthorized",
        text: "You are not authorized to use this service",
        type: "warning",
        confirmButtonColor: "#cddc39",
        confirmButtonText: "OK"
      })
      this.$router.push({ name: "upgrading-examination-register" })
    }
  },
  /*mounted() {
    var counter = 0
    var vm = this
    window.setIntervalConfirm = setInterval(function() {
      counter += 1

      if (vm.exam_name == "") {
        vm.fetchData()
      }

      if (counter === 3) {
        clearInterval(setIntervalConfirm)
      }
    }, 20000)
  },*/
  methods: {
    fetchData() {
      var vm = this
      vm.disabled = true
      vm.sending = true
      vm.downloaded = true
      var data = {
        token: vm.$route.params.token
      }
      const options = {
        method: "POST",
        data: data,
        url: examSlotIndexUrl
      }
      axios(options)
        .then(function(response) {
          Vue.set(vm.$data, "exam_name", response.data.exam_name)
          if (response.data.model) {
            Vue.set(vm.$data, "models", response.data.model)
          }

          if (response.data.unauthorized) {
            swal({
              title: "Unauthorized",
              text: "You are not authorized to use this service",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push({ name: "upgrading-examination-register" })
          }

          vm.disabled = false
          vm.sending = false
          vm.downloaded = false
        })
        .catch(function(error) {
          console.log(error.message)
          vm.disabled = false
          vm.sending = false
          vm.downloaded = false
          swal({
            title: "Failed",
            text:
              "Please reload the page. A system timeout or failure has occured",
            type: "warning",
            confirmButtonColor: "#cddc39",
            confirmButtonText: "OK"
          })
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    submit() {
      var vm = this
      swal({
        title: "Confirm",
        text: "Do you want to submit the center?",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#CDDC39",
        cancelButtonColor: "#F44336",
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel"
      }).then(result => {
        if (result.value) {
          vm.fab_button()
        } else if (
          // Read more about handling dismissals
          result.dismiss === "cancel"
        ) {
          swal({
            title: "Cancelled",
            text: "center was not submitted",
            type: "error",
            confirmButtonColor: "#cddc39",
            confirmButtonText: "OK"
          })
        }
      })
    },
    fab_button() {
      var vm = this
      vm.disabled = true
      vm.sending = true
      vm.downloaded = true
      var data = {
        token: vm.$route.params.token,
        slot: vm.user_slot
      }
      const options = {
        method: "POST",
        data: data,
        url: examSlotCreateUrl
      }
      axios(options)
        .then(function(response) {
          if (response.data.stored) {
            swal({
              title: "Success",
              text: "Your center has been saved successfully",
              type: "success",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push({ name: "upgrading-examination-register" })
          } else if (response.data.few) {
            vm.fetchData()
            swal({
              title: "Attention",
              text: "The center is full. Please select a different center.",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }

          if (response.data.unauthorized) {
            swal({
              title: "Unauthorized",
              text: "You are not authorized to use this service",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push({ name: "upgrading-examination-register" })
          }
          vm.disabled = false
          vm.sending = false
          vm.downloaded = false
        })
        .catch(function(error) {
          console.log(error.message)
          vm.disabled = false
          vm.sending = false
          vm.downloaded = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/upgrading-exam-center.vue